import type { IUserProfileSearchInfo as IUserProfileSearchInfoDto } from '../../../repositories/chats/entities/user_profile/UserProfileSearchInfo';
import type { IUserProfileSearchInfo } from '../../../types/userProfile';

export const mapSearchInfo = (
  searchInfo: IUserProfileSearchInfoDto | null | undefined,
): IUserProfileSearchInfo | null => {
  if (!searchInfo) {
    return null;
  }

  const { title, tags } = searchInfo;

  return {
    title,
    tags,
  };
};
